export default {

    start: function (apiFunction, meantime, doneFunction = (data) => data.done ) {

        const pathName = window.location.pathname

        return new Promise((resolve, reject) => {

            return loop({ apiFunction, meantime, pathName, resolve, reject, doneFunction })

        })

    }

}

function loop({ apiFunction, meantime, pathName, resolve, reject, doneFunction }) {

    apiFunction()
        .then(data => {

            if (doneFunction(data)) {

                resolve(data)

            } else {

                if (meantime) {

                    meantime(data)

                }

                if (pathName === window.location.pathname) {

                    waiting({ apiFunction, meantime, pathName, resolve, reject, time: data.retry, doneFunction })

                }

            }

        })
        .catch(error => {

            reject(error)

        })

}

function waiting({ apiFunction, meantime, pathName, resolve, reject, time, doneFunction }) {

    setTimeout(function () {

        loop({ apiFunction, meantime, pathName, resolve, reject, doneFunction })

    }, time)
}

